/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type SubscriptionRegionNameEnum = 'Asia Pacific' | 'North America' | 'Europe / Middle East / Africa' | 'South America' | 'GLOBAL';

export const SubscriptionRegionNameEnum = {

    ASIA_PACIFIC: 'Asia Pacific' as SubscriptionRegionNameEnum,

    NORTH_AMERICA: 'North America' as SubscriptionRegionNameEnum,

    EUROPE___MIDDLE_EAST___AFRICA: 'Europe / Middle East / Africa' as SubscriptionRegionNameEnum,

    SOUTH_AMERICA: 'South America' as SubscriptionRegionNameEnum,

    GLOBAL: 'GLOBAL' as SubscriptionRegionNameEnum
};

